import React from "react";
import {NomenclaturesCategoryPage} from "./NomenclaturesCategoryPage";
import {useNomenclaturesCategory} from "./useNomenclaturesCategory";

function NomenclaturesCategory() {
  return <NomenclaturesCategoryPage {...useNomenclaturesCategory()} />;
}

export default NomenclaturesCategory;
